module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"facetMappingTitle":"Accès rapides"},"en":{"facetMappingTitle":"Rapid access"},"pt":{"facetMappingTitle":"Atalho"},"de":{"facetMappingTitle":"Schnellzugriff"},"es":{"facetMappingTitle":"Acceso directo"},"it":{"facetMappingTitle":"Accesso rapido"},"nl":{"facetMappingTitle":"Snelle toegang"}}')
  delete Component.options._Ctor
}
